class Enums {
    static ShiftsAlternation = {
        None: '0',
        StartWithDay: '1',
        StartWithNight: '2'
    };
}

export { Enums };
